import { jsx } from "react/jsx-runtime";
export const ReactComponent = (props) => /* @__PURE__ */ jsx("svg", { ...props, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", children: /* @__PURE__ */ jsx("path", { d: "M10.6739 1.68018L1.99709 10.357M10.4971 10.357L1.82031 1.68018", stroke: "#595959" }) });
